import { render, staticRenderFns } from "./ScorePanel.vue?vue&type=template&id=325e123a&scoped=true&"
import script from "./ScorePanel.vue?vue&type=script&lang=js&"
export * from "./ScorePanel.vue?vue&type=script&lang=js&"
import style0 from "./ScorePanel.vue?vue&type=style&index=0&id=325e123a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e123a",
  null
  
)

export default component.exports